module.exports = __webpack_public_path__ + "fonts/Renault-Global.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/icons/Renault-Global.eot
// module id = 367
// module chunks = 0